module.exports = __webpack_public_path__ + "static/neversecondlogo-fd9f47d338ceecde65f28f7ae62d7c4c.png";